var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApprovePdf(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24716 11.0798L5.2474 11.08C5.49953 11.3482 5.85141 11.5 6.21916 11.5L6.22499 11.5L6.22859 11.5C6.59863 11.4973 6.95333 11.3406 7.20379 11.0651C7.20398 11.0648 7.20418 11.0646 7.20437 11.0644L14.8174 2.73234C14.8174 2.73232 14.8174 2.7323 14.8174 2.73228C15.3134 2.18958 15.2764 1.34583 14.7332 0.84928L14.7327 0.848868C14.1895 0.353609 13.3469 0.389197 12.8485 0.934267L12.8484 0.934409L6.20574 8.20433L3.13804 4.93881C3.13797 4.93875 3.13791 4.93868 3.13785 4.93861C3.13781 4.93858 3.13778 4.93854 3.13775 4.9385C2.63414 4.40184 1.79039 4.37616 1.25377 4.87949L1.25331 4.87992C0.718226 5.38306 0.688855 6.227 1.19497 6.76427C1.1951 6.7644 1.19522 6.76454 1.19535 6.76467L5.24716 11.0798Z",
    fill: "#969696",
    stroke: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovePdf);
export default __webpack_public_path__ + "static/media/approvePdf.f49a5f9b060d687bc3b5633cb2b900c7.svg";
export { ForwardRef as ReactComponent };